import React, { forwardRef } from 'react'

const SelectedItems = forwardRef(({ selectedValue, handleSelected }, ref) => (
  <div ref={ref} className="selected-items-group">
    {
      selectedValue.map((item, index) => {
        return <span
          className='selected-item'
          key={index}>
          {item.name}
          {(!item?.is_required || parseInt(item?.is_required) !== 1) &&
            <span onClick={() => handleSelected(item.idIndex, index)}>x</span>
          }
        </span>
      })
    }
  </div>
));

export default SelectedItems;